import React, { useCallback, useRef, useState } from "react";
import { connect } from "react-redux";
import "../../../../../om/css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    HeaderFilter,
    SearchPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";

const SubLotResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "e6b1c4a2-7d38-4f9a-b2e1-8c0d5a3f2b74";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);

    const onSelectionChanged = ({ selectedRowsData }) => {
        if (props.onSubLotSelected) {
            props.onSubLotSelected(selectedRowsData[0]);
        }
    };

    return (
        <div style={{ height: '100%' }}>
            <DataGrid
                onExporting={(e) => {
                    if (window.handleDevExtremeDataGridExport) {
                        window.handleDevExtremeDataGridExport(e);
                    }
                }}
                ref={dataGrid}
                height="100%"
                dataSource={props.data}
                keyExpr="RowId"
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                remoteOperations={true}
                columnAutoWidth={true}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <HeaderFilter visible={true} />
                <SearchPanel visible={true} width={240} placeholder="Search..." />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                {/* Default-visible columns */}
                <Column dataField="CustomerName" caption="Customer Name" />
                <Column dataField="SublotCode" caption="Sublot" sortOrder="asc" />
                <Column dataField="Description1" caption="Description 1" />
                <Column dataField="Description2" caption="Description 2" />
                <Column dataField="Department" caption="Department" />
                <Column dataField="ConsigneeName" caption="Consignee" />
                <Column dataField="ItemCode" caption="Item" />
                <Column dataField="LotCode" caption="Lot" />
                <Column dataField="Status" caption="Status" />
                <Column dataField="LocationCode" caption="Location" />
                <Column dataField="OnHand" caption="On Hand" />
                <Column dataField="Available" caption="Available" />
                <Column dataField="NetAvailable" caption="Net Available" />
                {/* Column chooser (hidden by default) */}
                <Column dataField="CustomerIdentity" caption="Customer" visible={false} />
                <Column dataField="ConsigneeId" caption="Consignee ID" visible={false} />
                <Column dataField="RecordNumber" caption="Record #" visible={false} />
                <Column dataField="OutUnavailable" caption="Out Unavailable" visible={false} />
                <Column dataField="InReceiving" caption="In Receiving" visible={false} />
                <Column dataField="OutShipped" caption="Out Shipped" visible={false} />
                <Column dataField="InOrdered" caption="In Ordered" visible={false} />
                <Column dataField="OutOrdered" caption="Out Ordered" visible={false} />
                <Column dataField="InFuture" caption="In Future" visible={false} />
                <Column dataField="OutFuture" caption="Out Future" visible={false} />
                <Column dataField="BOReciving" caption="BO Receiving" visible={false} />
                <Column dataField="BOShipped" caption="BO Shipping" visible={false} />
                <Column dataField="UnitTrWeight" caption="Unit Tr Weight" visible={false} />
                <Column dataField="Unitprice" caption="Unit Price" visible={false} />
                <Column dataField="Alternateid" caption="Alternate Id" visible={false} />
                <Column dataField="Intransactionnumber" caption="In Transaction #" visible={false} />
                <Column dataField="Recurringstorage" caption="Recurring Storage" visible={false} />
                <Column dataField="Size1" caption="Size 1" visible={false} />
                <Column dataField="Size2" caption="Size 2" visible={false} />
                <Column dataField="Dateintroduced" caption="Date Introduced" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="Dateavailable" caption="Date Available" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="DateExpiration" caption="Date Expiration" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="Creationdatetime" caption="Creation Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="Creationuserid" caption="Created By" visible={false} />
                <Column dataField="Lastupdatedatetime" caption="Last Updated" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="Lastupdateuserid" caption="Last Updated By" visible={false} />
                <Column dataField="Userdefinedcode1" caption="Code 1" visible={false} />
                <Column dataField="Userdefinedcode2" caption="Code 2" visible={false} />
                <Column dataField="Userdefinedcode3" caption="Code 3" visible={false} />
                <Column dataField="Userdefinedcode4" caption="Code 4" visible={false} />
                <Column dataField="Userdefinedcode5" caption="Code 5" visible={false} />
                <Column dataField="Userdefinedcode6" caption="Code 6" visible={false} />
                <Column dataField="Userdefinedcode7" caption="Code 7" visible={false} />
                <Column dataField="Userdefinedcode8" caption="Code 8" visible={false} />
                <Column dataField="Userdefinedcode9" caption="Code 9" visible={false} />
                <Column dataField="Userdefinedcode10" caption="Code 10" visible={false} />
                <Column dataField="Userdefinedreference1" caption="Reference 1" visible={false} />
                <Column dataField="Userdefinedreference2" caption="Reference 2" visible={false} />
                <Column dataField="Userdefinedreference3" caption="Reference 3" visible={false} />
                <Column dataField="Userdefinedreference4" caption="Reference 4" visible={false} />
                <Column dataField="Userdefinedreference5" caption="Reference 5" visible={false} />
                <Column dataField="Userdefinedreference6" caption="Reference 6" visible={false} />
                <Column dataField="Userdefinedreference7" caption="Reference 7" visible={false} />
                <Column dataField="Userdefinedreference8" caption="Reference 8" visible={false} />
                <Column dataField="Userdefinedreference9" caption="Reference 9" visible={false} />
                <Column dataField="Userdefinedreference10" caption="Reference 10" visible={false} />
                <Column dataField="Userdefineddate1" caption="Date 1" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="Userdefineddate2" caption="Date 2" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="Userdefineddate3" caption="Date 3" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="Userdefineddate4" caption="Date 4" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="Userdefineddate5" caption="Date 5" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="Userdefineddate6" caption="Date 6" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="Userdefineddate7" caption="Date 7" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="Userdefineddate8" caption="Date 8" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="Userdefineddate9" caption="Date 9" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="Userdefineddate10" caption="Date 10" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="Userdefinedquantity1" caption="Quantity 1" visible={false} />
                <Column dataField="Userdefinedquantity2" caption="Quantity 2" visible={false} />
                <Column dataField="Userdefinedquantity3" caption="Quantity 3" visible={false} />
                <Column dataField="Userdefinedquantity4" caption="Quantity 4" visible={false} />
                <Column dataField="Userdefinedquantity5" caption="Quantity 5" visible={false} />
                <Column dataField="Userdefinedquantity6" caption="Quantity 6" visible={false} />
                <Column dataField="Userdefinedquantity7" caption="Quantity 7" visible={false} />
                <Column dataField="Userdefinedquantity8" caption="Quantity 8" visible={false} />
                <Column dataField="Userdefinedquantity9" caption="Quantity 9" visible={false} />
                <Column dataField="Userdefinedquantity10" caption="Quantity 10" visible={false} />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(SubLotResult);
